exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ds-card-image{display:block;max-width:100%;width:100%}", ""]);

// exports
exports.locals = {
	"ds-card-image": "ds-card-image"
};